import React from "react";

export const PerkIcon = ({
  width = 36,
  height = 37,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 36 37"
    fill="none"
  >
    <g clipPath="url(#clip0_5039_15749)">
      <path
        d="M21.8306 11.5902C19.6245 8.25313 13.8658 9.00507 12.5906 12.7968C9.98024 8.84907 2.39226 10.618 3.14403 16.3753L4.83815 29.3496L33.5734 25.5975L31.8793 12.6232C31.1275 6.86586 23.3398 7.10464 21.8306 11.5902ZM29.4867 22.5454L8.00415 25.3505L6.77039 15.9018C6.72343 15.5422 6.58026 14.4457 8.07432 14.2506C8.24476 14.2284 9.12285 14.146 9.50987 14.7373L13.661 21.0225L16.0591 13.8821C16.2854 13.2143 17.1479 13.0694 17.3184 13.0472C17.4888 13.0249 18.3596 12.9435 18.7498 13.5308L22.901 19.816L25.299 12.6756C25.5249 12.0043 26.3911 11.8589 26.5615 11.8367C28.0556 11.6416 28.1987 12.7381 28.2457 13.0977L29.4795 22.5463L29.4867 22.5454Z"
        fill="#CCF4FE"
      />
      <path
        d="M27.4295 7.75062C25.3407 7.57156 22.8637 8.48664 21.6962 10.561C19.2422 7.95193 14.158 8.6158 12.4562 11.7676C8.83158 8.27144 1.86103 10.6733 2.60014 16.4466L4.29426 29.4209C4.33247 29.7136 4.60628 29.9181 4.90727 29.8788L33.6425 26.1266C33.9435 26.0873 34.1557 25.8194 34.1174 25.5268L32.4233 12.5525C31.9975 9.29125 29.5632 7.93458 27.4295 7.75062ZM32.9605 25.14L5.31312 28.75L3.68805 16.3046C3.39572 14.0658 4.47177 12.2794 6.56776 11.5253C8.38194 10.8724 10.8773 11.1992 12.1274 13.0906C12.242 13.2621 12.4499 13.3569 12.6602 13.3294C12.8705 13.3019 13.0475 13.1605 13.1138 12.9618C13.6371 11.4054 15.0994 10.2893 16.9344 10.0497C18.7693 9.81014 20.4692 10.5133 21.3746 11.8831C21.4892 12.0546 21.6971 12.1494 21.9074 12.122C22.1177 12.0945 22.2947 11.953 22.361 11.7544C23.0836 9.60537 25.4113 8.64882 27.3323 8.81394C29.5517 9.00463 31.0503 10.4548 31.3427 12.6936L32.9677 25.139L32.9605 25.14Z"
        fill="#637381"
      />
      <path
        d="M26.4995 11.3072C25.8359 11.3939 25.0386 11.7562 24.783 12.5103L22.7429 18.5784L19.2129 13.2376C18.7723 12.5744 17.9123 12.4285 17.2523 12.5147C16.5923 12.6009 15.795 12.9632 15.5431 13.7168L13.5029 19.7849L9.97298 14.4441C9.53186 13.7774 8.66874 13.6355 8.00512 13.7222C7.24358 13.8216 6.00071 14.2457 6.22628 15.9732L7.46005 25.4219C7.49826 25.7145 7.77207 25.919 8.07306 25.8797L29.5556 23.0746C29.8566 23.0353 30.0687 22.7674 30.0305 22.4747L28.7967 13.0261C28.5712 11.2985 27.2611 11.2078 26.4995 11.3072ZM28.8735 22.088L8.4789 24.751L7.31419 15.8312C7.2502 15.3411 7.26565 14.8944 8.14322 14.7799C8.17224 14.7761 8.82907 14.6939 9.04963 15.0272L13.2008 21.3125C13.3154 21.4839 13.5232 21.5787 13.7335 21.5513C13.9439 21.5238 14.1209 21.3824 14.1871 21.1837L16.5852 14.0433C16.7132 13.668 17.3655 13.5792 17.3909 13.5759C17.4163 13.5726 18.0731 13.4904 18.2896 13.8207L22.4407 20.1059C22.5553 20.2774 22.7632 20.3722 22.9735 20.3447C23.1838 20.3173 23.3608 20.1758 23.4271 19.9771L25.8252 12.8368C25.9527 12.458 26.6086 12.3687 26.6377 12.3649C27.5152 12.2503 27.6448 12.6781 27.7088 13.1681L28.8735 22.088Z"
        fill="#637381"
      />
    </g>
    <defs>
      <clipPath id="clip0_5039_15749">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.0961914 4.69922) rotate(-7.43933)"
        />
      </clipPath>
    </defs>
  </svg>
);
